import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";

export function getGroups(page, pageSize) {
  const pagingParams =
      page !== undefined && pageSize !== undefined ? `?page=${page}&pageSize=${pageSize}` : ``,
        url = `${urls.GROUPS_URL}${pagingParams}`;

    const request = axios.get(url);

  return { type: ActionTypes.GET_GROUPS, payload: request };
}
